var url = {
    apiUrl_LoginCheck: '/mobile/j_spring_security_check',
    apiUrl_PwFlag: '/api/v1/pwFlag',
    apiurl_MenuStateManager: '/api/v1/menuStateManager',
    apiurl_Data: '/api/v1/Data',
    apiurl_masterData: '/api/v1/masterdata',
    apiUrl_LoginSearch: '/api/v1/LoginSearch',
    apiUrl_MenuSearch: '/api/v1/MenuSearch',
    apiUrl_Initialization: '/api/v1/initialization',
    apiUrl_AttendExpenseAttendancesExpense: 'api/v1/attendances/expense',
    apiUrl_AttendExpenseAttendances: 'api/v1/attendances',
    apiUrl_StaffAttendances: 'api/v1/staff/attendances',
    apiUrl_StaffTargetYm: 'api/v1/staff/targetYm',
    apiUrl_StaffHourwage: 'api/v1/staff/hourwage',//スタッフ時給取得
    apiUrl_StaffTypeAllowance: 'api/v1/staff/typeAllowance',//各手当時給情報取得
    apiUrl_StaffTotalAllowance: 'api/v1/staff/totalAllowance',//時給合計情報取得
    apiUrl_StaffAllowance: 'api/v1/staff/allowance',//スタッフ案件手当取得
    apiUrl_WorkJobstate: 'api/v1/work/jobstate',//作業開始・終了・戻す
    apiUrl_Check: 'api/v1/check',//チェック
    apiUrl_filesUpdate: '/api/v1/files',
    apiUrl_FilesSearch: '/api/v1/files',
    apiUrl_AttendPhotoInfo: '/api/v1/photoInfo',
    apiUrl_NoticeDetailSearch: '/api/v1/noticeDetail',
    apiUrl_Notice: '/api/v1/notice',
    apiUrl_PwChange: '/api/v1/pwChange',
    apiUrl_PaymentStatus: '/api/v1/paymentStatus',
    apiUrl_PaymentDetail: '/api/v1/paymentDetail',
    apiUrl_MyNoInfo: '/api/v1/myNoInfo',
    apiUrl_ContractStatus: '/api/v1/contractStatus',//契約状況
    apiUrl_ContractStatusNew: '/api/v1/contractStatusNew',//新契約確認情報保存
    apiUrl_ContractDetail: '/api/v1/contractDetail',//契約明細検索
    apiUrl_ContractDetailNew: '/api/v1/contractDetailNew',//新契約明細検索
    apiUrl_SalaryAccountInfo: '/api/v1/salaryAccountInfo',//給与振込口座申請
    apiUrl_BankInfo: '/api/v1/bankInfo',//銀行検索
    apiUrl_BranchInfo: '/api/v1/branchInfo',//支店検索
    apiUrl_ReadFlag: '/api/v1/readFlag',//誓約・同意既読フラグ検索
    apiUrl_PrivateCarInfo: '/api/v1/privateCarInfo',//マイカー通勤申請
    apiUrl_SelfDoc: '/api/v1/selfDoc',//本人確認書類検索
    apiUrl_ResidentCard: '/api/v1/residentCard',//在留カード
    apiUrl_StaffApplyConfirmLog: '/api/v1/staffApplyConfirmLog',//スタッフ申請確認ログ保存
    apiUrl_EmergencyContact: '/api/v1/emergencyContact',//緊急連絡先申請
    apiUrl_AddressData: '/api/v1/bo/addressdata', //共通住所
    apiUrl_BasicStaffInfo: '/api/v1/basicStaffInfo',//スタッフ基本情報申請
    apiUrl_UserInfo: '/api/v1/userInfo',//社員情報検索
    apiUrl_PwReset: '/api/v1/pwReset',//パスワードリセット用社員情報検索
    apiUrl_TempCode: '/api/v1/tempCode',//パスワードリセット認証コード
    apiUrl_myCarUseInfo: '/api/v1/myCarUseInfo',//マイカー使用有無検索
    apiUrl_holidaySearch: '/api/v1/bo/holiday',//有休申請一覧検索
    apiUrl_holidayDetailSearch: '/api/v1/bo/holidayDetail',//有休申請詳細検索 
    apiUrl_holidaySave: '/api/v1/bo/holidayDetail',//有休申請一覧検索
    apiUrl_jobIntroSearch: '/api/v1/bo/jobIntro',//お仕事案内一覧検索
    apiUrl_jobSelectSearch: '/api/v1/bo/jobSelect',//お仕事選択一覧検索
    apiUrl_jobDetailSearch: '/api/v1/bo/jobDetail',//お仕事詳細一覧検索
    apiUrl_jobApplySearch: '/api/v1/bo/jobApply',//お仕事申請一覧検索
    apiUrl_jobApplyUpdate: '/api/v1/bo/jobApply',//お仕事申請保存
    apiUrl_storeFieldInfo: '/api/v1/storeFieldInfo',//店舗現場情報-検索
    apiUrl_googleapis: '/api/v1/googleapis',//googleapis-検索
    apiUrl_expcgi: '/api/v1/expcgi',//ekispert-検索
    apiUrl_laberNoticeInfo: '/api/v1/bo/laberNoticeInfo',// 労働条件通知書検索
    apiUrl_laborNoticeOutput: '/api/v1/bo/laborNoticeOutput',// 労働条件通知書PDF
    apiUrl_workAmountList: '/api/v1/bo/workAmountList',// 作業量一覧検索
    apiUrl_WorksCwSelect: 'api/v1/works/cw',//作業実績情報（通常）-検索

    routerUrl_Login: '/login',
    routerUrl_PasswordReset: '/passwordReset',
    routerUrl_PasswordResetDeliver: '/passwordResetDeliver',
    routerUrl_Top: '/top',
    routerUrl_Menu: '/Menu',
    routerUrl_K0001: '/k0001',
    routerUrl_K0002: '/k0002',
    routerUrl_K0003: '/k0003',
    routerUrl_K0005: '/k0005',
    routerUrl_K0006: '/k0006',
    routerUrl_K0007: '/k0007',
    routerUrl_K0008: '/k0008',
    routerUrl_I0001: '/i0001',
    routerUrl_I0002: '/i0002',
    routerUrl_I0003: '/i0003',
    routerUrl_I0004: '/i0004',
    routerUrl_DialogAddress: '/DialogAddress',
    routerUrl_I0005: '/i0005',
    routerUrl_I0006: '/i0006',
    routerUrl_I0007: '/i0007',
    routerUrl_I0008: '/i0008',
    routerUrl_I0009: '/i0009',
    routerUrl_I0010: '/i0010',
    routerUrl_I0011: '/i0011',
    routerUrl_I0012: '/i0012',
    routerUrl_I0013: '/i0013',

    routerUrl_I0014: '/i0014',
    routerUrl_I0015: '/i0015',
    routerUrl_I0016: '/i0016',
    routerUrl_I0017: '/i0017',
    routerUrl_I0018: '/i0018',
    routerUrl_I0019: '/i0019',
    routerUrl_I0020: '/i0020',

    routerUrl_C0001: '/c0001',
    routerUrl_C0002: '/c0002',
    routerUrl_C0003: '/c0003',
    routerUrl_S0001: '/s0001',
    routerUrl_D0001: '/d0001',
    routerUrl_P0001: '/p0001',
    routerUrl_P0002: '/p0002',
    routerUrl_P0003: '/p0003',
    routerUrl_P0004: '/p0004',
    routerUrl_B0001: '/b0001',
    routerUrl_B0002: '/b0002',
    routerUrl_W0001: '/w0001',
    routerUrl_W0002: '/w0002',
    routerUrl_Error: '/error',

    imgUrl_UserInfo: 'image/userInfo/',//写真path

    axiosBaseURL: 'https://rmsa-s.ajis-group.com',
    routerUrl_K0006_btn1URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUN1JIVFhYTUFPMkJEV0YyMzROVEw1N09HSy4u',
    routerUrl_K0006_btn2URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUNUhaQU5RRlZPNlVFQ0NSWUMxUkRJWDZJSi4u',
    routerUrl_K0006_btn3URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUMzVLODNPQUQxVlRYTE8wMlU5MkU4MDFWVC4u',
    routerUrl_K0006_btn4URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUQlBEMzAyMUxSUE5VUjJCWDFHTENCNDVRMi4u',
    routerUrl_K0006_btn5URL: 'https://teachme.jp/81935/manuals/9882163/',
    routerUrl_K0008_btn1URL: 'https://teachme.jp/81935/manuals/11145917/',
    routerUrl_K0005_btn1URL: 'https://cloud.staffexpress.jp/ajis/neo/index.php',
    routerUrl_K0005_btn2URL: 'http://www.ajis-mds.co.jp/corporate/branches/',
    routerUrl_K0005_btn3URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm-z1cK7MiIJLkAt28D4VRDRUOURBNkFaVUdNUjlYMlBGSUxRTVlWRURXNSQlQCN0PWcu',
    routerUrl_paid_apply: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUQ1BYVDFPRTM2VEFVWkpLWTAyNE1ZUURFVS4u',
    routerUrl_I0011_btn1URL: 'image/workRule/嘱託社員就業規則＆ハラスメント防止規程&育児・介護休業等に関する規則.pdf',
    routerUrl_I0011_btn2URL: 'image/workRule/個人情報取得及び取扱い明示.pdf',
    routerUrl_I0011_btn3URL: 'image/workRule/給与支払方法の明示.pdf',
    routerUrl_I0011_btn4URL: 'image/workRule/雇用契約書の電磁的交付による明示.pdf',
    routerUrl_I0011_btn5URL: 'image/workRule/給与明細等の電磁的交付による明示書.pdf',
    routerUrl_I0014_btn1URL: 'https://teachme.jp/81935/manuals/9734936/',
    routerUrl_I0014_btn2URL: 'https://teachme.jp/81935/manuals/7692119/',

    routerUrl_immediate_payment: 'https://amsit.ajis-group.com/search-job/',//メニュー - タイムシート - お仕事紹介 （本番環境）
    routerUrl_job_introduction: 'https://amsit.ajis-group.com/payment/',//メニュー - タイムシート - 即払い （本番環境）
}

module.exports = url


//////////////////
// WEBPACK FOOTER
// ./config/sysConfig.js
// module id = kspH
// module chunks = 2